import { render } from "./ScanPage.vue?vue&type=template&id=cf895672&scoped=true"
import script from "./ScanPage.vue?vue&type=script&lang=js"
export * from "./ScanPage.vue?vue&type=script&lang=js"

import "./ScanPage.vue?vue&type=style&index=0&id=cf895672&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf895672"]])

export default __exports__